export default "__VITE_ASSET__c1653251__"